import React from 'react';
import './App.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, Routes } from 'react-router-dom';
import Home from './Components/screens/Home';
import { TopNav } from './Components/HeaderAndfooter/Header';
import Footer from './Components/HeaderAndfooter/Footer';
import { Booking } from './Components/screens/Booking';
import { Charters } from './Components/screens/Charters' 
import { Gallery } from './Components/screens/Gallery';

function App() {
  return (
    <>
    {/* <TopNav/> */}
    <Routes>
            <Route
              path="/"
              element={<Home/>}/>
              
              <Route
              path="/Booking"  
              element={<Booking/>}/>
              
              <Route
              path="/Charters"  
              element={<Charters/>}/>

              <Route
              path="/Gallery"
              element={<Gallery/>}/>
              
      </Routes>
    <Footer/>
    </>
  );
}

export default App;
